import React, { Component } from 'react'
import { Button, Divider, Modal } from 'semantic-ui-react'
import { Editor } from '@tinymce/tinymce-react'
import MediasContainer from '../containers/MediasContainer'
import { inlineStyle } from '../styles/custom'
import '../styles/RichTextEditor.css'

class RichTextEditor extends Component {

  constructor(props) {
    super(props)

    this.state = {
      editor: null,
      placeholder: '<p class="mce-placeholder">' + (this.props.placeholder || 'Contenu') + '</p>',
      modal: {
        open: false,
        insertUnavailable: true
      },
      media: null
    }
  }

  // Handle click a media
  handleClick = (event, media) => {
    this.setState({
      media: media,
      modal: {
        ...this.state.modal,
        insertUnavailable: false
      }
    })
  }

  // Click on insert button
  onClick = (e) => {
    if (this.state.media) {
      const ext = this.state.media.file.split(/#|\?/)[0].split('.').pop().trim()
      const extImages = ['jpg', 'jpeg', 'png', 'svg']

      if (extImages.indexOf(ext) !== -1) {
        this.state.editor.insertContent('<img src="' + this.state.media.file + '" alt="">')
      } else {
        this.state.editor.insertContent('<a target="_blank" href="' + this.state.media.file + '">' + this.state.media.file + '</a>')
      }

      this.setState({
        media: null,
        modal: {
          open: false,
          insertUnavailable: true
        }
      })
    }
  }

  // Close modal
  onClose = () => {
    this.setState({
      media: null,
      modal: {
        open: false,
        insertUnavailable: true
      }
    })
  }

  handleEditorChange = (e) => {
    const content = e.target.getContent()
    if (content !== this.state.placeholder) {
      this.props.onChange({
        target: {
          id: this.props.id,
          value: content
        }
      })
    }
  }

  render() {
    return (
      <div>
        <Modal open={this.state.modal.open} style={inlineStyle.modal}>
          <Modal.Header>Selectionnez un média</Modal.Header>
          <Modal.Content scrolling>
            <MediasContainer handleClick={this.handleClick} />
          </Modal.Content>
          <Modal.Actions>
            <Button floated='left' onClick={this.onClose}>Annuler</Button>
            <Button floated='right' onClick={this.onClick} disabled={this.state.modal.insertUnavailable} primary>Insérer</Button>
            <Divider clearing hidden fitted />
          </Modal.Actions>
        </Modal>
        <Editor
          apiKey='p3a7s24p5meh3fq1o4dje1wy6bcy0guobv7rsp1t3n3sq4tv'
          initialValue={this.props.placeholder || 'Contenu'}
          init={{
            plugins: 'lists link image textcolor imagetools autoresize',
            toolbar: 'bold italic underline link | h1 h2 h3 formatselect | bullist numlist blockquote | alignleft aligncenter alignright alignjustify | image file forecolor',
            block_formats: 'Paragraph=p;Heading 2=h2;Heading 3=h3;',
            statusbar: false,
            menubar: false,
            autoresize_min_height: 140,
            relative_urls : false,
            remove_script_host : false,
            convert_urls : true,
            content_style: '#tinymce { padding-bottom: 10px !important; font-family: Lato,"Helvetica Neue",Arial,Helvetica,sans-serif; margin: 0 14px; } .mce-placeholder { color: rgba(191,191,191,.87); }',
            init_instance_callback: (editor) => {
              const { placeholder } = this.state

              if (this.props.value) {
                editor.setContent(this.props.value)
              } else {
                editor.setContent(placeholder)
              }

              editor.on('paste', (e) => {
                e.preventDefault()
                const content = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text')
                editor.insertContent(content)
              })

              editor.on('focus', (e) => {
                if (placeholder === editor.getContent()) {
                  editor.setContent('')
                } else if (!editor.getContent()) {
                  editor.setContent(placeholder)
                }
              })

              editor.on('blur', (e) => {
                if (!editor.getContent()) {
                  editor.setContent(placeholder)
                }
              })
            },
            setup: (editor) => {
              editor.addButton('file', {
                icon: 'file',
                tooltip: 'File manager',
                onclick: () => {
                  this.setState({
                    editor: editor,
                    modal: {
                      ...this.state.modal,
                      open: true
                    }
                  })
                }
              });
            }
          }}
          onChange={this.handleEditorChange}
        />
      </div>
    )
  }
}

export default RichTextEditor



// WEBPACK FOOTER //
// ./src/components/RichTextEditor.js